import { useMemo } from 'react';
import { useSearchParams } from 'react-router';

import { SearchJobRefinement } from '#/modules/search/constants/refinements/searchJobsRefinementTypes';
import type { SearchRefinementType } from '#/modules/search/constants/refinements/searchRefinementTypes';
import { SEARCH_REFINEMENT_NAMES } from '#/modules/search/constants/refinements/searchRefinementTypes';
import {
  useSearchFiltersByName,
  useSearchRadius,
} from '#/modules/search/contexts/SearchContext';
import type { SearchFiltersByName } from '#/modules/search/types/FiltersByName/SearchFiltersByName';
import type { SearchType } from '#/modules/search/types/SearchType';

export function useActiveRefinementCount(searchType: SearchType): number {
  const [searchParams] = useSearchParams();
  const searchFiltersByName = useSearchFiltersByName();
  const searchRadius = useSearchRadius();

  return useMemo(() => {
    const refinementNames = SEARCH_REFINEMENT_NAMES[searchType];

    return refinementNames.reduce(
      (acc: number, refinementType: SearchRefinementType) => {
        const urlParams = searchParams.getAll(refinementType);
        if (urlParams.length > 0) return acc + urlParams.length;

        if (refinementType === SearchJobRefinement.RADIUS && searchRadius) {
          return acc + 1;
        }

        const value: unknown =
          searchFiltersByName?.[refinementType as keyof SearchFiltersByName];
        if (Array.isArray(value)) return acc + value.length;

        return acc;
      },
      0,
    );
  }, [searchParams, searchFiltersByName, searchRadius, searchType]);
}
